import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { showSuccessSnackbar } from 'modules/snackbar';
import { addAllList } from 'modules/common';
import { getDate, makeRowColumn, getHeadObj } from 'lib/commonLib';
import {
  IpBlockList,
  addIpBlock,
  ipUnBlock,
  addMultiIpBlock,
  IpBlocKAbsgCtgrTpCode,
} from 'lib/api/server';

import NewInput from 'components/atoms/NewInput';
import MbButton from 'components/atoms/MbButton';
import MbTooltip from 'components/atoms/MbTooltip';
import NewButton from 'components/molecules/NewButton';
import FunctionWrap from 'components/molecules/FunctionWrap';
import TableBtnWrap from 'components/molecules/TableBtnWrap';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import FilterCollection from 'components/organisms/FilterCollection';
import MbUpload from 'components/organisms/MbUpload';

import IpBlockModal from './IpBlockModal';

const IpBlock = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let initParams = {
    sort: 'desc',
    order: 'REG_DTTM',
    useYn: '01', // Default: 사용
    intrcpTp: 'all',
    intrcpIp: '',
    intrcpRsn: '',
  };
  const isServerPage = window.location.pathname === '/system/server/ip_block';
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);
  const [reFetch, setReFetch] = useState(false);
  const [uploading, setUploading] = useState(false);
  const initModal = {
    open: false,
    params: { intrcpIp: '', intrcpRsn: '', intrcpTp: 'all' },
  };
  const [modal, setModal] = useState(initModal);
  const [error, setError] = useState({ intrcpIp: false, intrcpRsn: false });
  const [categorySeleteList, setCategorySeleteList] = useState([]);

  const useABlockList = [
    { label: '사용', value: '01' },
    { label: '미사용', value: '02' },
  ];

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  useEffect(() => {
    IpBlocKAbsgCtgrTpCode()
      .then((response) => {
        const { data } = response.data;
        setCategorySeleteList(data);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally((f) => f);
    // eslint-disable-next-line
  }, []);

  /**
   * set params함수
   * @param {Object} newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };
  const getTempParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };
  const handleModalValue = (newParams) => {
    setModal({ ...modal, params: { ...modal.params, ...newParams } });
  };

  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setTempParams(initParams);
      setParams(initParams);
    } else if (JSON.stringify(tempParams) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setTempParams(initParams);
      setParams(initParams);
    }
  };

  const handleSearchClick = () => {
    setParams(tempParams);
  };

  const handleModalOpen = (data, state) => {
    let newModal = { ...modal, open: true, type: state };
    if (state === 'add') {
      newModal = {
        ...newModal,
        params: { intrcpIp: '', intrcpRsn: '', intrcpTp: '01' },
      };
    } else if (state === 'log') {
      newModal = { ...newModal, params: {}, rowObj: { ...data } };
    } else if (state === 'delete') {
      newModal = {
        ...newModal,
        params: {
          intrcpTp: data['INTRCP_TP'],
          intrcpIp: data['INTRCP_IP'],
          userUnqKey: data['USER_UNQ_KEY'],
        },
        rowObj: { ...data },
      };
    }
    setModal(newModal);
  };

  const handleUpload = (status) => {
    setUploading(status);
  };

  const callUpload = async (taskId) => {
    setReFetch(true);
    handleUpload(true);
    await addMultiIpBlock({ taskId: taskId })
      .then((response) => {
        let msg = t('IP 차단이 완료되었습니다.');
        if (response.data.data.emFlag) {
          msg += '(' + t('차단 금지 IP 포함') + ')';
        }
        handleClickSnackbar({ message: msg, option: { type: 'info' } });
        setReFetch(true);
      })
      .catch((error) => {
        handleClickSnackbar({ message: error, option: { type: 'error' } });
      })
      .finally(() => {
        handleUpload(false);
      });
  };

  const handleSubmit = () => {
    let newError = {};
    switch (modal.type) {
      case 'add':
        if (modal.params.intrcpIp === '' || modal.params.intrcpRsn === '') {
          if (modal.params.intrcpIp === '') {
            newError = { ...newError, intrcpIp: true };
          } else {
            newError = { ...newError, intrcpIp: false };
          }
          if (modal.params.intrcpRsn === '') {
            newError = { ...newError, intrcpRsn: true };
          } else {
            newError = { ...newError, intrcpRsn: false };
          }
        } else {
          newError = { intrcpIp: false, intrcpRsn: false };
        }
        setError({ ...error, ...newError });
        addIpBlock({ ...modal.params })
          .then((response) => {
            const { message } = response.data;
            handleClickSnackbar({
              message: message,
              option: { type: 'success' },
            });
            setReFetch(true);
            handleClose();
          })
          .catch((error) => {
            handleClickSnackbar({ message: error, option: { type: 'error' } });
          })
          .finally(() => {
            setReFetch(false);
          });
        break;
      case 'delete':
        ipUnBlock(modal.params)
          .then((response) => {
            const { message } = response.data;
            handleClickSnackbar({
              message: message,
              option: { type: 'success' },
            });
            setReFetch(true);
          })
          .catch((error) => {
            handleClickSnackbar({ message: error, option: { type: 'error' } });
          })
          .finally(() => {
            setReFetch(false);
            handleClose();
          });
        break;
      default:
        break;
    }
  };

  /**
   * 파일 다운로드 (임시)
   */
  const downloadFile = () => {
    axios({
      method: 'GET',
      url: '/download/ip_block_sample.xlsx',
      responseType: 'blob', // 가장 중요함
    }).then((response) => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers['content-type'] })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ip_block_sample.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  };

  const customized = {
    USER_UNQ_KEY: { merged: true },
    INTRCP_TP: { merged: true },
    INTRCP_IP: {
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'INTRCP_IP');
        let content;
        content = (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['INTRCP_IP'],
              bodyItem1.type,
              bodyItem1.format
            )}
            icon="faExternalLink"
            toolTipTitle={t('IP차단 상세내역')}
            onClick={(e) => handleModalOpen(rowObj, 'log')}
          />
        );
        return content;
      },
    },
  };

  const addColumnList = (() => {
    const result = new Map();
    result.set(0, {
      id: 'MANAGE_ICONS',
      label: t('관리'),
      align: 'center',
      makeRowFunc: (data) => {
        return (
          <TableBtnWrap>
            <MbTooltip title={t('삭제')}>
              <MbButton
                iconBtn
                icon="faTrashAlt"
                onClick={(e) => handleModalOpen(data, 'delete')}
              />
            </MbTooltip>
          </TableBtnWrap>
        );
      },
    });
    return result;
  })();

  const handleClose = () => {
    setModal({ ...modal, open: false });
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <div
      style={
        isServerPage
          ? undefined
          : {
              backgroundColor: '#fff',
              padding: 15,
              borderRadius: 4,
            }
      }
    >
      <FunctionWrap loading={false}>
        <NewButton onClick={(e) => handleModalOpen(e, 'add')}>
          {t('차단 IP 등록')}
        </NewButton>
        <MbUpload
          name="upload"
          label={t('다중등록')}
          callBack={callUpload}
          uploading={uploading}
        />
        <NewButton onClick={(e) => downloadFile(e)}>
          {t('샘플 다운로드')}
        </NewButton>
      </FunctionWrap>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <FilterCollection
          label={t('카테고리')}
          value={tempParams.intrcpTp}
          name="intrcpTp"
          type="radio"
          params={tempParams}
          list={addAllList(categorySeleteList, 'CODE_VAL', 'CODE_ID', 'all')}
          labelKey="CODE_VAL"
          valueKey="CODE_ID"
          callBack={getTempParam}
        />
        <FilterCollection
          label={t('차단 사용여부')}
          value={tempParams.useYn}
          name="useYn"
          type="radio"
          params={tempParams}
          list={useABlockList}
          labelKey="label"
          valueKey="value"
          callBack={getTempParam}
        />
        <NewInput
          name="intrcpIp"
          type="filter"
          label={t('차단 IP')}
          params={tempParams}
          callBack={getTempParam}
          value={tempParams.intrcpIp}
        />
        <NewInput
          type="filter"
          label={t('비고')}
          name="intrcpRsn"
          value={tempParams.intrcpRsn}
          params={tempParams}
          callBack={getTempParam}
        />
        <NewButton onClick={handleSearchClick}>{t('검색')}</NewButton>
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={IpBlockList}
        customized={customized}
        addColumnList={addColumnList}
        useSearch={false}
        useTotal={false}
        reFetch={reFetch}
      />
      <IpBlockModal
        modal={modal}
        handleClose={handleClose}
        categorySeleteList={categorySeleteList}
        handleModalValue={handleModalValue}
        handleSubmit={handleSubmit}
        error={error}
      />
    </div>
  );
};

export default IpBlock;
